export default class HighlightsComponent {
    constructor() {
        HighlightsComponent.show()
    }

    static show() {
        const $target = $('.ancre-points-forts')
        const block = '[data-element="customer-wp-block-highlights"]'
        const blockLink = '[data-element="customer-wp-block-highlights-link"]'

        if ($(block).length > 0 && $target.length > 0) {
            $(blockLink).addClass('active')

            $(blockLink).on('click', () => {
                $('html, body').animate(
                    {
                        scrollTop: $target.offset().top - 100,
                    },
                    600,
                )
            })
        }
    }
}
